/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Create_User_ExistsInputs */

const en_admin_create_user_exists = /** @type {(inputs: Admin_Create_User_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This email already belongs to a user:`)
};

const de_admin_create_user_exists = /** @type {(inputs: Admin_Create_User_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese E-Mail gehört bereits zu einem Nutzer:`)
};

/**
* | output |
* | --- |
* | "This email already belongs to a user:" |
*
* @param {Admin_Create_User_ExistsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_create_user_exists = /** @type {((inputs?: Admin_Create_User_ExistsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Create_User_ExistsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_create_user_exists(inputs)
	return en_admin_create_user_exists(inputs)
});